import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { ApiBaseService } from './api-base.service';
import { SharedService } from './shared.service';

import { VendorFormCanCompleteDto, VendorFormModel, VendorFormSubmitDto } from '@shared/models/VendorFormModel';
import { Country } from '@shared/models/Enums';


@Injectable()
export class ApiVendorFormService extends ApiBaseService {

    constructor(public http: HttpClient, public sharedService: SharedService) {
        super(http, sharedService);
    }

    // GET: api/admin/vendorforms/full/reads/v1/{id}
    getFullVendorForm(id: number, country: Country): Promise<VendorFormModel> {

        return this.http.get(`${this.baseUrl}/api/admin/vendorforms/full/reads/v1/${id}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    return new VendorFormModel(result);
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar el formulario: ${errMsg}`));
                }
            );
    }

    // POST: api/admin/vendorforms/submit/v1
    submitVendorForm(dto: VendorFormSubmitDto, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/vendorforms/submit/v1`, dto, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // POST: api/admin/vendorforms/can-access/reads/v1/{code}
    checkUniqueCode(code: string, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/vendorforms/can-access/reads/v1/${code}`, null, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // GET: api/admin/vendorforms/{formId}/can-complete/reads/v1/{customerId}
    checkCustomerCanComplete(formId: number, customerId: number, country: Country): Promise<VendorFormCanCompleteDto> {

        return this.http.get(`${this.baseUrl}/api/admin/vendorforms/${formId}/can-complete/reads/v1/${customerId}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    return result as VendorFormCanCompleteDto;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al validar la disponibilidad del formulario: ${errMsg}`));
                }
            );
    }
}
